"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const styledComponents_1 = require("../styledComponents");
const SearchBarInput = ({ onChange }) => {
    return (react_1.default.createElement(material_1.Box, { sx: { gridColumn: 'span 12', display: 'flex', justifyContent: 'center' } },
        react_1.default.createElement(material_1.Box, { style: {
                width: '100%',
                borderRadius: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            } },
            react_1.default.createElement(styledComponents_1.Instructions, { style: {
                    fontSize: '1.2em',
                    paddingBottom: '20px',
                    textAlign: 'center',
                    lineHeight: '.7em',
                } },
                "Search for ",
                react_1.default.createElement(styledComponents_1.Tag, { style: { margin: '2px' } }, "principalid"),
                ",",
                ' ',
                react_1.default.createElement(styledComponents_1.Tag, { style: { margin: '2px' } }, "accountId"),
                ", or",
                ' ',
                react_1.default.createElement(styledComponents_1.Tag, { style: { margin: '2px' } }, "txHash"),
                " :"),
            react_1.default.createElement(styledComponents_1.CustomTextField, { fullWidth: true, onChange: onChange, InputProps: {
                    endAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: "end" },
                        react_1.default.createElement(styledComponents_1.ThemedSearchIcon, null))),
                } }))));
};
exports.default = SearchBarInput;
